export function getArrayValue(value: string | Array<string>): Array<string> {
  return Array.isArray(value) ? value : [value];
}
